// extracted by mini-css-extract-plugin
export default {"contactInfo":"Contactinfo_contactInfo__iSzau","infoBlock":"Contactinfo_infoBlock__VpOiW","infoBlockHeader":"Contactinfo_infoBlockHeader__fpO5m"};